import React from "react";
import depression from "../../assets/images/depression.png";
import couple from "../../assets/images/couples.png";
import individual from "../../assets/images/individual.png";
import antiStress from "../../assets/images/anti-stress.png";
import PrimaryButton from "../common/PrimaryButton";

type Card = {
  title1: string;
  title2: string;
  description: string;
  image: string;
  link: string;
  bg?: boolean;
};

const cards: Card[] = [
  {
    title1: "Consulting",
    title2: "",
    description:
      "Our consulting services at Psyche Ethos provide tailored strategies to help you overcome personal challenges and enhance mental well-being. Whether you're facing stress, anxiety, or life transitions, our expert consultants offer actionable insights and practical tools to guide you towards a healthier mindset and a balanced life.",
    image: depression,
    link: "/therapy",
  },
  {
    title1: "Advisory",
    title2: "",
    description:
      "At Psyche Ethos, our advisory services are designed to empower you with the tools and strategies needed to overcome emotional hurdles and embrace mental well-being. We offer personalized guidance that helps you unlock your full potential, build emotional resilience, and create a balanced life.",
    image: couple,
    link: "/therapy",
    bg: true,
  },
  {
    title1: "Coaching",
    title2: "",
    description:
      "Unlock your true potential with Psyche Ethos' coaching services. Our tailored coaching approach helps you build emotional intelligence, resilience, and the mindset needed to overcome challenges and achieve your goals. Build emotional intelligence, resilience, and a growth mindset to overcome challenges and achieve your goals with confidence and clarity.",
    image: individual,
    link: "/therapy",
  },
  {
    title1: "Mentoring",
    title2: "",
    description:
      "At Psyche Ethos, our mentoring services are rooted in authenticity and connection, providing a safe space for personal growth. We offer thoughtful, one-on-one guidance to help you navigate life’s challenges and unlock your full potential. We help you align with your true self, cultivate resilience, and confidently pursue a life of purpose and fulfillment.",
    image: antiStress,
    link: "/therapy",
    bg: true,
  },
];

type Props = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const WhatWeOffer = ({ setIsOpen }: Props) => {
  return (
    <div className="w-full">
      <div className="py-6 px-4 sm:py-14 sm:px-12 bg-gradient-to-l from-[#0CACDE66]/40 to-[#0CACDEE5]/90">
        <h2 className="text-lg sm:text-xl text-white uppercase">
          What We Offer
        </h2>
        <h1 className="text-5xl text-white mt-4">
          Find balance
          <span className="text-5xl ml-1 italic font-eiko-thin">
            and harmony with us.
          </span>
        </h1>
      </div>
      <div className="mb-10">
        {cards.map((card, index) => (
          <div
            key={index}
            className={`${card.bg ? "py-0" : "py-6"} sm:${
              card.bg ? "py-0" : "py-12"
            } px-4 sm:px-12 flex flex-col ${
              card.bg === true ? "sm:flex-row-reverse" : "sm:flex-row"
            } gap-4 sm:gap-10 ${
              card.bg
                ? "bg-gradient-to-l from-[#0CACDE66]/10 to-[#0CACDEE5]/20"
                : ""
            } `}
          >
            <div id="advisory" className="rounded-xl w-full">
              <div className="overflow-hidden rounded-xl">
                <img
                  src={card.image}
                  alt=""
                  className="hover:scale-110 transition-all w-full duration-300"
                />
              </div>
            </div>
            <div className="flex flex-col justify-center gap-8 w-full">
              <h1 className="text-3xl sm:text-5xl">
                {card.title1}
                <span className="text-3xl sm:text-5xl italic font-eiko-thin text-primary">
                  {card.title2}
                </span>
              </h1>
              <p className="">{card.description}</p>
              <PrimaryButton
                onClick={() => setIsOpen(true)}
                icon
                className="max-w-[300px]"
              >
                REQUEST APPOINTMENT
              </PrimaryButton>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhatWeOffer;
